import { createFeatureSelector, createSelector } from '@ngrx/store'
// import { accountListSelector, accountsInvitedReselector } from './accounts.reselector'
 import { filteredFrontPageEventsReselector, frontPageFilterUIDataReselector, invitedToEventsReselector } from './filteredEvents.reselector'
// import { eventListReselector } from './events.reselector'
import { AllSameKeyValuesEnforcer } from '../../helpers/helpers'; 
import { accountStateSelector } from '../accounts.era';
import { userStateSelector } from '../user.era';
import { eventStateSelector } from '../events.era';
import { settingsStateSelector } from '../settings.era';
import { accountListSelector, accountsInvitedReselector } from './accounts.reselector';
import { eventListReselector } from './events.reselector';
import { jsonCopyObject } from 'globals/helpers/helpers';
// import { UserState } from '../user.store';
// import { SettingsState } from '../setting.store';
// import { AccountsState } from '../accounts.store';


// // This stuff is complicated enough that it should have its own reselector file!

const userId = createSelector(userStateSelector, (state) => state.user.uid);
const userEmailVerified = createSelector(userStateSelector, (state) => state.user.emailVerified);
const allEventsLoaded = createSelector(eventStateSelector, (state) => state.all_events_loaded);
const showClosedEvents = createSelector(settingsStateSelector, (state) => state.user.event_show_closed);
const accountsLoading = createSelector(accountStateSelector, (state) => state.loading);

export interface AccountEventStates { loading; emailUnverified; noAccounts; noEvents; hiddenClosedEventsOnly, invitationsOnly; fresh; normal; noResults; noSubscription; noSubscriptionWithEvents; noSubscriptionWithEventsButFilteredOut, noSubscriptionWithEventsButClosedAndInvisible, noSubscriptionInvitationsOnly, notPublished, notShared, logisticsNotShared, suspended, singleSuspended }
export const accountEventStates: AllSameKeyValuesEnforcer<AccountEventStates > = {
  loading: 'loading', emailUnverified: 'emailUnverified', noAccounts: 'noAccounts', noEvents: 'noEvents', invitationsOnly: 'invitationsOnly', fresh: 'fresh', normal: 'normal', noResults: 'noResults', noSubscriptionWithEvents: 'noSubscriptionWithEvents', noSubscription: 'noSubscription', noSubscriptionWithEventsButFilteredOut: 'noSubscriptionWithEventsButFilteredOut', hiddenClosedEventsOnly: 'hiddenClosedEventsOnly', noSubscriptionWithEventsButClosedAndInvisible: 'noSubscriptionWithEventsButClosedAndInvisible', noSubscriptionInvitationsOnly: 'noSubscriptionInvitationsOnly', notPublished: 'notPublished', notShared: 'notShared', logisticsNotShared: 'logisticsNotShared', suspended: 'suspended', singleSuspended: 'singleSuspended'
}


// reselectors take a maximum of 9 arguments as inputs, so I need to create more reselectors to feed into the isFreshReselector below
const loadingAccountsEventsReselector = createSelector(
  accountsLoading,
  userId,
  allEventsLoaded,
  accountListSelector,
  (accountsLoading, userId, allEventsLoaded, accountList) => {
    const allAccountsHaveDocketsOrNoAccounts = !accountList.length || accountList.every(account => account.hasOwnProperty('docket'))
    const accountsLoaded = !accountsLoading && allAccountsHaveDocketsOrNoAccounts
    // console.log({ userId, accountsLoading, eventsLoaded, accountsLoaded, accountList: jsonCopyObject(accountList) })
    return !userId || !allEventsLoaded || !accountsLoaded
  }
)

const loadingAndVerified = createSelector(
  loadingAccountsEventsReselector,
  userEmailVerified,
  (loading, verified) => ({ loading, verified })
)

export const accountEventStateReselector = createSelector(
  frontPageFilterUIDataReselector,
  filteredFrontPageEventsReselector,
  accountListSelector,
  accountsInvitedReselector,
  invitedToEventsReselector,
  eventListReselector,
  showClosedEvents,
  loadingAndVerified,
  (frontPageFilterUIData, filteredEvents, accountList, accountsInvited, invitedToEvents, eventList, showClosedEvents, loadedAndVerified) => {
    // if (loadedAndVerified.loading) return accountEventStates.loading

    console.log({ loading: loadedAndVerified.loading, verified: loadedAndVerified.verified, filteredEvents: jsonCopyObject(filteredEvents), accountList: jsonCopyObject(accountList), accountsInvited, invitedToEvents, eventList, showClosedEvents })
    if (frontPageFilterUIData) {
      const { inactiveAccountIdSet, filters } = frontPageFilterUIData
      if (filters.accounts?.some(id => inactiveAccountIdSet.has(id))) return accountEventStates.singleSuspended
    }
    if(!loadedAndVerified.verified) return accountEventStates.emailUnverified;

    if (!accountList.length && eventList.length) return accountEventStates.normal

    const invitationsOnly = (invitedToEvents.length && invitedToEvents.length === eventList.length) || (!eventList.length && accountsInvited.length)

    if (!accountList.length && invitationsOnly) return accountEventStates.noSubscriptionInvitationsOnly

    if (!accountList.length) return accountEventStates.noAccounts

    console.log({ accountList, eventList, showClosedEvents })

    const docketStatuses = accountList.map(({ docket }) => docket && docket.status ? docket.status : "incomplete")
    console.log({ docketStatuses })
    const noSubscription = docketStatuses.every(status => ['canceled', 'suspended'].includes(status))
    const fresh = docketStatuses.every(status => status === 'fresh')
    
    // accountList.find(account => account.hasOwnProperty('docket')).docket
    // const docket = accountList[0].docket
    // console.log({ docket })

    const hasOnlyHiddenClosedEvents = eventList.length && eventList.filter(e => e.closed).length === eventList.length && !showClosedEvents

    if (eventList.length && noSubscription && hasOnlyHiddenClosedEvents) return accountEventStates.noSubscriptionWithEventsButClosedAndInvisible // # 3 No subscription with events but filtered out.

    if (eventList.length && noSubscription && !filteredEvents.length) return accountEventStates.noSubscriptionWithEventsButFilteredOut // # 4 No subscription with events but filtered out.

    if (hasOnlyHiddenClosedEvents) return accountEventStates.hiddenClosedEventsOnly // #5 Hidden closed events only

    if (eventList.length && !filteredEvents.length) return accountEventStates.noResults // #6 No filtered results

    if (noSubscription && invitationsOnly) return accountEventStates.noSubscriptionInvitationsOnly // #8 No subscription but has invitations
    if (noSubscription && eventList.length) return accountEventStates.noSubscriptionWithEvents // #9 No subscription with events.  Doesn't matter if they're invitations or not, they will be displayed but clicking new event will lead to the button taking you to the subscriptions page

    if (invitationsOnly) return accountEventStates.invitationsOnly // #10 invitations only => this is not working properly since all events are visible once invited to an account

    if (noSubscription) return accountEventStates.noSubscription // #11 No subscription, no events, no invitations

    if (!eventList.length && !fresh) return accountEventStates.noEvents // #12 No events

    if (eventList.length && fresh) return accountEventStates.normal // Events from other users present

    if (fresh) return accountEventStates.fresh // #13 Fresh state - needs to be shown

    return  accountEventStates.normal
  }
)